import React from 'react';
import { openingLines } from '../../data/reel';
import { SceneProps } from '../../types/reel';
import { punch } from '../../utils/reelMath';
import { SceneLayer } from './SceneLayer';
import { TypeText } from './TypeText';
export function OpeningScene({
  time,
  scene
}: SceneProps) {
  let active = 0;
  openingLines.forEach((l, i) => {
    if (time >= l.at) active = i;
  });
  return <SceneLayer time={time} start={scene.start} end={scene.end} fade={0.12} data-id="element-93" data-mp="30gzlurs2ukui">
      {() => <div className="absolute inset-0 bg-cream" data-id="element-94" data-mp="35fatcvuwgj9k">
          {openingLines.map((line, i) => <div key={line.text} className="absolute left-[150px] top-1/2 w-[1560px] -translate-y-1/2" style={{
        opacity: i === active ? 1 : 0,
        transform: `translateY(-50%) scale(${punch(time, line.at, 0.04, 0.3)})`,
        transformOrigin: 'left center'
      }} data-id="element-95" data-mp="3aex6z6en41iw" data-mpi={i}>
              <TypeText time={time} start={line.at} cps={34} segments={line.text} className="block text-[120px] font-medium leading-[1.02] tracking-[-0.045em] text-ink" data-id="element-96" data-mp="2mojczachvslo" />
            </div>)}
        </div>}
    </SceneLayer>;
}